import {flare} from "@flareapp/flare-client";
import {flareVue} from "@flareapp/flare-vue";
import Vue from "vue";
import VCalendar from "v-calendar";
import {Notyf} from "notyf";
import Quill from "quill";
import ImageUploader from "quill-image-uploader";
import {createFloorplanPins, listenToFloorplanClick} from "./floorplan";
// import {matchHeight} from "./match-height";
import {setTriangleBottomMargins} from "./triangle-bottom";
import {initSignaturePads} from "./signature";
import 'livewire-vue';
import collapse from "./collapse";
import initCollapse from "./collapse";
import {initTabsToDropdown} from "./tabs-to-dropdown";
import {initNumberScales} from "./number-scale";

// only launch in production, we don't want to waste your quota while you're developing.
if (process.env.NODE_ENV === "production") {
  flare.light("gsdgQcMJfL5LQZZAXZ2VFgMLpTAXX8Gy");
}

require("./bootstrap");
require("./gallery");
require("./isEqual");
require("./pinpoint-image");
require("./dashboard-welcome-video");
require("./live-chat-cta");
require("./view-floorplans-gallery");

// require('@fortawesome/fontawesome-free/js/all');
const moment = require("moment");
require("moment/locale/en-gb");
const AutoNumeric = require("autonumeric");

window.Vue = Vue;

Vue.use(require("vue-moment"), {
  moment
});
Vue.use(flareVue);
Vue.component("pagination", require("laravel-vue-pagination"));
Vue.component('VueAutonumeric', require('vue-autonumeric'));
require("./segmented-circle");
require("./splide");
const Storages = require("js-storage");

// Define our storage.
window.storage = Storages.localStorage;

Quill.register("modules/imageUploader", ImageUploader);

// Create an instance of Notyf
window.notyf = new Notyf({
  position: {
    x: "center",
    y: "top"
  },
  duration: 5000,
  dismissible: true,
  types: [
    {
      type: "success",
      background: "#737B4C"
    },
    {
      type: "error",
      background: "#e74c3c"
    }
  ]
});

window.api_url = "/api/v1";
window.basket_url = "/dashboard/customise-your-home/step-3";
window.order_pending_url = "/dashboard/customise-your-home/pending";

String.prototype.toTitleCase = function () {
  var i, j, str, lowers, uppers;
  str = this.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });

  // Certain minor words should be left lowercase unless
  // they are the first or last words in the string
  lowers = [
    "A",
    "An",
    "The",
    "And",
    "But",
    "Or",
    "For",
    "Nor",
    "As",
    "At",
    "By",
    "For",
    "From",
    "In",
    "Into",
    "Near",
    "Of",
    "On",
    "Onto",
    "To",
    "With"
  ];
  for (i = 0, j = lowers.length; i < j; i++)
    str = str.replace(new RegExp("\\s" + lowers[i] + "\\s", "g"), function (
      txt
    ) {
      return txt.toLowerCase();
    });

  // Certain words such as initialisms or acronyms should be left uppercase
  uppers = ["Id", "Tv"];
  for (i = 0, j = uppers.length; i < j; i++)
    str = str.replace(
      new RegExp("\\b" + uppers[i] + "\\b", "g"),
      uppers[i].toUpperCase()
    );

  return str;
};

// Load all vue components.
let files = require.context("./components/admin", true, /\.vue$/i);

files.keys().map(key =>
  Vue.component(
    key
      .split("/")
      .pop()
      .split(".")[0],
    files(key).default
  )
);

// Can't seem to do this without repeating the code, any fancy loops or merging messes up.
files = require.context("./components/dashboard", true, /\.vue$/i);

files.keys().map(key =>
  Vue.component(
    key
      .split("/")
      .pop()
      .split(".")[0],
    files(key).default
  )
);

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  //
});

Vue.filter('titlecase', function (value) {
  return value.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
});

Vue.filter('formatDate', function (value) {
  if (value) {
    const dateObj = new Date(value);

    // format to display as Tuesday 12th January 2021
    const day = dateObj.toLocaleString('en-GB', {weekday: 'long'});
    const dayOfMonth = dateObj.getDate();
    const month = dateObj.toLocaleString('en-GB', {month: 'long'});
    const year = dateObj.getFullYear();

    return `${day} ${dayOfMonth}${dayOfMonth === 1 ? 'st' : dayOfMonth === 2 ? 'nd' : dayOfMonth === 3 ? 'rd' : 'th'} ${month} ${year}`;
  } else {
    return '';
  }

});

Vue.filter("money", function (value) {
  value = value.toString();

  if (value === "") {
    return 0;
  }

  // Thousand seperators.
  value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Ensure decimal is 2 places.
  if (value.split(".").length > 1) {
    if (value.split(".")[1].length === 1) {
      value += "0";
    }
  }

  return value;
});

const app = new Vue({
  el: "#app",
  data: {
    basket: null
  },
  comments: true,
});

/**
 * Axios interceptors.
 */
window.axios.interceptors.response.use(
  function (response) {
    if (
      response.data &&
      response.data.messages &&
      response.data.messages.length > 0
    ) {
      for (const x in response.data.messages) {
        if (response.data.messages[x].type === "success") {
          notyf.success(response.data.messages[x].message);
        } else {
          notyf.error(response.data.messages[x].message);
        }
      }
    }

    return response;
  },
  function (error) {
    // Show alert if Laravel validation error.
    if (error.response && error.response.status === 422) {
      for (const x in error.response.data.errors) {
        for (const y in error.response.data.errors[x]) {
          notyf.error(error.response.data.errors[x][y]);
        }
      }
    }

    return Promise.reject(error);
  }
);

/**
 * Bootstrap modal helper.
 * This retains the BS4 syntax but allows us to call it on a jQuery object.
 *
 * @param action
 * @param options
 * @returns {*}
 */
$.fn.modal = function(options = {}, action = 'show') {
  return this.each(function() {
    let myModal = $(this).data('bs.modal');
    if (!myModal) {
      myModal = new bootstrap.Modal(this, options);
      $(this).data('bs.modal', myModal);
      myModal[action]();
    } else if (typeof action === 'string' && typeof myModal[action] === 'function') {
      myModal[action]();
    }
  });
};

function initTooltips() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}
$(document).ready(function () {
  initTabsToDropdown();
  initTooltips();

  if ($('#gdpr-pop-up').length > 0) {
    $('#gdpr-pop-up').modal('show');
  }

  // Any breadcrumbs that have overflown? Scroll them to the end.
  $('.breadcrumbs_new').each(function () {
    const $this = $(this);

    // If the scroll width is greater than the inner width, we have an overflow.
    if ($this[0].scrollWidth > $this.innerWidth()) {
      // Instantly scroll to the end.
      $this.scrollLeft($this[0].scrollWidth);
    }
  });

  // Init Quill editors.
  const toolbarOptions = [["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{list: "ordered"}, {list: "bullet"}], [{indent: "-1"}, {indent: "+1"}], // outdent/indent
    [{direction: "rtl"}], // text direction

    [{size: ["small", false, "large", "huge"]}], // custom dropdown
    [{header: [2, 3, 4, 5, 6, false]}],

    [{align: []}],

    ["image"], ["clean"] // remove formatting button
  ];

  $(".editor").each(function () {
    const editor = new Quill($(this)[0], {
      theme: "snow",
      modules: {
        toolbar: toolbarOptions,
        imageUploader: {
          upload: file => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function () {
                axios
                  .post(
                    window.api_url + "/admin/videos/image",
                    {
                      image: reader.result
                    }
                  )
                  .then(res => {
                    if (res.data.success) {
                      resolve(res.data.url);
                    }
                  })
                  .catch(err => {
                    resolve(false);
                  })
                  .finally(() => {
                    //
                  });
              };

              reader.onerror = function (error) {
                resolve(false);
              };
            });
          }
        }
      }
    });

    const $input = $(this).data("input")
      ? $($(this).data("input")).first()
      : null;

    if ($input !== null) {
      editor.root.innerHTML = $input.val();

      editor.on("text-change", function (delta, oldDelta, source) {
        $input.val(editor.root.innerHTML);
      });
    }
  });

  listenToFloorplanClick();

  $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (event) {
    createFloorplanPins();
  });

  $('[data-bm-close][data-bm-open]').on('click', function () {
    const $this = $(this);
    $($this.data('bm-close')).one('hidden.bs.modal', function () {
      $($this.data('bm-open')).modal('show');
    }).modal('hide');
  });

  $('input.currency').each(function () {
    new AutoNumeric($(this)[0], {
      allowDecimalPadding: "floats",
      currencySymbol: "£",
      unformatOnSubmit: true,
    });
  });

  // Attempt to focus a tab if there's a hash.
  const selectedTab = window.location.hash;
  $('[href="' + selectedTab + '"]').trigger('click');

  // Push tab changes to the hash.
  $('[data-bs-toggle="tab"]').on('click', function (e) {
    window.location.hash = $(this).attr('href');
  });

  Livewire.hook('message.processed', (message, component) => {
    initTooltips();
  });
});

$(window).on("load", function () {
  createFloorplanPins();
  // matchHeight();
  setTriangleBottomMargins();
  initSignaturePads();
  initCollapse();
});

$(window).on('resize orientationchange', function () {
  requestAnimationFrame(() => {
    createFloorplanPins();
    // matchHeight();
    setTriangleBottomMargins();
  });
});

initNumberScales();
